import { Root, color, ITooltipSettings, IGraphicsSettings } from '@amcharts/amcharts5';
import { IXYAxis } from '@amcharts/amcharts5/.internal/charts/xy/series/XYSeries';
import {
  IAxisLabelSettings,
  IDateAxisSettings,
  ILineSeriesSettings,
  IValueAxisSettings,
  IXYChartSettings,
} from '@amcharts/amcharts5/xy';
import { startOfHour } from 'date-fns';

import { xAxisRenderer, yAxisRenderer } from 'utils/charts/charts';
import { AxisRendererSettings } from 'utils/charts/setAxisRenderer';
import { SHADOW, WHITE } from 'utils/colours';

export const getXYChartSettings = (): IXYChartSettings => ({
  panX: false,
  panY: false,
  maxTooltipDistance: 0,
});

export const yAxisSettings = (root: Root): IValueAxisSettings<any> => ({
  min: 0,
  max: 100,
  maxDeviation: 1,
  maxPrecision: 0,
  renderer: yAxisRenderer(root, {}),
});

export const xAxisSettings = (
  root: Root,
  minDateTimeRange: string,
  maxDateTimeRange: string
): IDateAxisSettings<any> => ({
  baseInterval: {
    timeUnit: 'hour',
    count: 1,
  },
  min: startOfHour(new Date(minDateTimeRange)).getTime(),
  max: new Date(maxDateTimeRange).getTime(),
  renderer: xAxisRenderer(root, {}),
  startLocation: 0,
  endLocation: 1,
});

export const lineSeriesSettings = (
  name: string,
  lineColor: string,
  xAxis: IXYAxis,
  yAxis: IXYAxis
): ILineSeriesSettings => ({
  locationX: 0,
  locationY: 0,
  name: name,
  xAxis: xAxis,
  yAxis: yAxis,
  valueYField: 'value',
  valueXField: 'date',
  stroke: color(lineColor),
});

export const formattingSettings = {
  numberFormatter: {
    numberFormat: '0.0',
    numericFields: ['valueY'],
  },
  dateFormatter: {
    dateFormat: 'HH:mm:ss MMM dd, yyyy',
    dateFields: ['valueX'],
  },
};

const fontSettings: IAxisLabelSettings = {
  fontSize: '0.875rem',
  fontWeight: '400',
  fontFamily: 'Inter, -apple-system, Arial, sans-serif',
  location: 0,
};

export const yAxisRendererSettings: AxisRendererSettings = {
  renderer: {
    minGridDistance: 15,
  },
  labels: {
    ...fontSettings,
    paddingRight: 16,
  },
};

export const xAxisRendererSettings: AxisRendererSettings = {
  labels: {
    ...fontSettings,
    paddingTop: 16,
  },
};

export const tooltipSettings: ITooltipSettings = {
  getFillFromSprite: false,
  getStrokeFromSprite: false,
  pointerOrientation: 'up',
};

export const graphicsSettings: IGraphicsSettings = {
  fill: color(WHITE),
  fillOpacity: 1,
  shadowColor: color(SHADOW),
  shadowBlur: 16,
  shadowOffsetX: 0,
  shadowOffsetY: 4,
  shadowOpacity: 0.25,
};
